import useReduceStore from 'hooks/ReduceStoreHook';
import OrderStore from 'stores/OrderStore';
import HttpService from 'service/HttpService';

export const useUserActiveOrders = function() {
    const orders = useReduceStore(OrderStore, (store) => store.getUserOrders(), 
                            () => HttpService.getMyOrders(), []);

    return orders;
}


// WEBPACK FOOTER //
// ./src/hooks/OrderHook.js